<template>
    <section class="settings-module">
        <!-- Loading -->
        <loading />

        <div class="settings-content">
            <div role="header" class="module-header">
                <div class="icon-text-wrapper mb-tablet-only">
                    <p
                        @click="showSidebarMenu()"
                        role="button"
                        class="turnback"
                    >
                        Menu
                    </p>
                </div>

                <h1 class="heading-4">Definições do centro</h1>

                <p class="color-text-body">
                    Gere as definições relacionadas com o centro onde estão os
                    teus espaços
                </p>
            </div>

            <form
                @submit.prevent="sendData()"
                class="form-module admin-backoffice-form"
                method="post"
                action=""
                aria-describedby="Definitions of Settings"
                enctype="application/x-www-form-urlencoded"
                autocomplete="on"
            >
                <div class="input-row">
                    <!-- Nome -->
                    <div class="input-row-item">
                        <div data-reference="name" class="item-label-input">
                            <label
                                for="name"
                                class="form-label body-1 strong-600"
                                >Nome</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('name', name)"
                                @focusout="inputValidationCase('name', name)"
                                v-model="name"
                                class="form-control body-1"
                                id="name"
                                placeholder="Nome"
                                maxlength="200"
                            />
                        </div>
                    </div>
                </div>

                <div class="input-row">
                    <!-- block of time -->
                    <div class="input-row-item">
                        <div class="item-label-input">
                            <label
                                for="turn_value"
                                class="form-label body-1 strong-600"
                                >Valor do período</label
                            >

                            <select
                                id="turn_value"
                                class="form-select selectturn"
                                aria-label="Choose Turn"
                                ref="selectturn"
                                @change="selectValue($event)"
                            >
                                <option
                                    v-for="(value, index) of turnvalues"
                                    :key="index"
                                    :data-referindex="index"
                                    :value="value.turn"
                                    :selected="value.selected"
                                >
                                    {{ `${value.turn} horas` }}
                                </option>
                            </select>
                            <small class="caption-md color-text-body"
                                >Horas correspondentes a um período de
                                tempo</small
                            >
                        </div>
                    </div>
                </div>

                <div class="input-row">
                    <!-- Precede Request -->
                    <div class="input-row-item">
                        <div class="item-label-input">
                            <label
                                for="requestlist-base"
                                class="form-label body-1 strong-600"
                                >Antecedência mínima para pedidos</label
                            >

                            <div id="requestlist-base" class="requestlist-base">
                                <span
                                    v-for="(val, index) in requestvalues"
                                    :key="val.id"
                                    role="button"
                                    data-action="request"
                                    :data-referindex="index"
                                    :data-value="val.request"
                                    :class="val.selected ? 'selected' : ''"
                                    class="requestlist body-1"
                                    ref="requestlist"
                                    @click="chooseProcedeRequest($event)"
                                >
                                    {{ `${val.value} horas` }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input-row">
                    <!-- Precede Request -->
                    <div class="input-row-item">
                        <div class="item-label-input">
                            <label
                                for="requestlist-base"
                                class="form-label body-1 strong-600"
                                >Antecedência mínima para editar reservas</label
                            >

                            <div id="requestlist-base" class="requestlist-base">
                                <span
                                    v-for="(val, index) in editvalues"
                                    :key="val.id"
                                    role="button"
                                    data-action="edit"
                                    :data-referindex="index"
                                    :data-value="val.edit"
                                    :class="val.selected ? 'selected' : ''"
                                    class="requestlist body-1"
                                    ref="editlist"
                                    @click="chooseProcedeRequest($event)"
                                >
                                    {{ `${val.value} horas` }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input-row">
                    <p class="strong-600 payment-module-action">
                        Módulo Pagamento
                    </p>

                    <div class="form-check-wrapper">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                type="radio"
                                name="payment_active"
                                id="payment_active"
                                v-model="payment"
                                :checked="settingsdata.data.payment === 1"
                                value="1"
                                @click="setRadioValue()"
                            />
                            <label
                                class="form-check-label"
                                for="payment_active"
                            >
                                Ativo
                            </label>
                        </div>
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                type="radio"
                                name="payment_inactive"
                                id="payment_inactive"
                                v-model="payment"
                                :checked="settingsdata.data.payment === 0"
                                value="0"
                                @click="setRadioValue()"
                            />
                            <label
                                class="form-check-label"
                                for="payment_inactive"
                            >
                                Inativo
                            </label>
                        </div>
                    </div>
                </div>

                <div class="btn-wrapper">
                    <button
                        type="submit"
                        class="btn btn-primary btnsubmit button-body"
                        :disabled="disabled"
                    >
                        Guardar alterações
                    </button>
                </div>
            </form>

            <!-- Response Messages -->
            <div
                @click="closeMessageBox($event)"
                class="responsebasemessage"
                ref="responsebasemessage"
            >
                <list-message />
            </div>
        </div>
    </section>
</template>
<script>
import fetchData from "./../../../fetchData.js";
import inputValidation from "./../../../validationInputs.js";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import responseMessage from "./../../../responseMessage.js";
import CardElement from "./../../elements/CardElement.vue";

("use strict");

export default {
    name: "SettingsModule",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        customdata: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            disabled: true,
            settingsdata: {},
            turnvalues: [],
            requestvalues: [],
            requestlist: [],
            name: "",
            inputNotIsValid: true,
            activeclass: "d-flex",
            responseTimeOut: 5000,
            customData: {},
            moduleData: {},
            global: {},
            payment: 1,
            editvalues: [],
        };
    },
    created() {
        //Set Settings Data
        this.customData = JSON.parse(this.customdata);
        this.moduleData = JSON.parse(this.moduledata);

        ["turnvalues", "requestvalues", "editvalues"].forEach(
            (value) => (this.$data[value] = this.customData[value])
        );

        //Set Settings Values
        this.moduleData.map((value) => (value.data = JSON.parse(value.data)));
        this.setSettingsValue("global");
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        setRadioValue() {
            //Enabled button
            this.disabled = false;
        },
        setSettingsValue(type) {
            this.settingsdata = this.moduleData.find(
                (value) => value.type === type
            );

            switch (type) {
                case "global":
                    this.name = this.settingsdata.data.name;
                    this.payment = this.settingsdata.data.payment;

                    ["turnvalues", "requestvalues", "editvalues"].forEach((value) => {
                        this.$data[value].map((val) => {
                            ["turn", "request", "edit"].forEach((valkey) => {
                                if (Object.hasOwn(val, valkey)) {
                                    if (
                                        val[valkey] ===
                                        this.settingsdata.data[valkey]
                                    ) {
                                        val.selected = true;
                                    }
                                }
                            });
                        });
                    });

                    break;
            }
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        inputValidationCase(inputid, inputvalue) {
            //Check by empty values
            if (inputvalue === "" || !inputvalue) {
                //Disable button
                this.disabled = true;

                return;
            }

            //Check Inputs
            switch (inputid) {
                //name
                case "name":
                    this.disabled = inputValidation.validNameCases(4, this.name)
                        ? false
                        : true;

                    break;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        selectValue(element) {
            //Check Data
            if (Number.isInteger(parseInt(element.target.value))) {
                //Set Turn
                this.global.turn = parseInt(element.target.value);

                //Enabled button
                this.disabled = false;

                return;
            }

            //Show Error Message
            inputValidation.createErrorMessageElement(
                element.target.getAttribute("id"),
                "Por favor apenas escolher períodos permitidos pelo sistema"
            );
        },
        chooseProcedeRequest(element) {
            //Check Data
            if (
                !Number.isInteger(
                    parseInt(element.currentTarget.getAttribute("data-value"))
                )
            ) {
                //Disable button
                this.disabled = true;

                return;
            }

            //Set Conditional
            let action = element.currentTarget.getAttribute("data-action");
            let list = this.$refs[`${action}list`];

            //Enabled button
            this.disabled = false;

            //Set Object
            this.global[`${action}`] = parseInt(
                element.currentTarget.getAttribute("data-value")
            );

            //Clean old Selected
            [...list].forEach((value) =>
                value.classList.remove("selected")
            );

            //Add Selected Class
            element.currentTarget.classList.add("selected");
        },
        sendData() {
            //Check Empty Values
            if (this.name === "") {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    document.querySelector(".responsebasemessage"),
                    "warning",
                    "Necessário preencher os inputs indicados como obrigatórios",
                    this.activeclass,
                    this.responseTimeOut
                );

                this.disabled = true;

                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Disabled Button
            this.disabled = true;

            //Set Data
            this.global.name =
                this.name.trim() !== this.moduleData[0].data.name.trim()
                    ? this.name.trim()
                    : this.moduleData[0].data.name.trim();
            this.global.turn = Object.hasOwn(this.global, "turn")
                ? this.global.turn
                : this.moduleData[0].data.turn;
            this.global.request = Object.hasOwn(this.global, "request")
                ? this.global.request
                : this.moduleData[0].data.request;
            this.global.edit = Object.hasOwn(this.global, "edit")
                ? this.global.edit
                : this.moduleData[0].data.edit;    
            this.global.payment = parseInt(this.payment);

            //Send Data
            let response = fetchData.structureTosendData(
                this.routineurl,
                {
                    global: this.global,
                    id: parseInt(this.moduleData[0].id),
                },
                this.csrftolken,
                "PUT"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Clean Data
                    this.global = {};

                    //Success Conditional
                    if (value.classname === "success") {
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000);
                    }
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        cardElement: CardElement,
    },
};
</script>
